import { Box } from '@mui/material';
import React from 'react';
import * as IMG from '../../../../helpers/ImagesUtils';
import CodeQrComponent from '../../../usuario/usu_entidades/components/code_qr';
import jsonStyles from '../../StylesCarnet.json';

const CodeqrCarnetComponent = ({
  carnetStore,
  notEdit,
  name,
  value,
  qrRef,
}) => {
  function getStyles(id) {
    return carnetStore.activo?.[id] ?? jsonStyles[id];
  }

  const isActivo = carnetStore.stylesCarnet?.id === name;

  return (
    <Box
      // onClick={() => _onClickComponent(codeQr)}
      sx={[
        {
          position: 'absolute',
          border: isActivo && !notEdit ? 'solid blue 1.5px' : null,
          cursor: 'pointer',
          '&:hover': notEdit
            ? null
            : {
                border: 'solid blue 1.5px',
              },
        },
        {
          display: getStyles(name).display,
          width: `${getStyles(name).width}%`,
          height:
            getStyles(name).height === 0
              ? 'auto'
              : `${getStyles(name).height}%`,
          left: `${getStyles(name).x}%`,
          top: `${getStyles(name).y}%`,
          verticalAlign: getStyles(name).textBaseline,
          backgroundColor: getStyles(name).backgroundColor,
          borderRadius: `${getStyles(name).borderRadius}px`,
          ...(!isActivo && {
            borderWidth: `${getStyles(name).borderWidth}px`,
          }),
          boxShadow: `${getStyles(name).textShadowX}px ${
            getStyles(name).textShadowY
          }px ${getStyles(name).textShadowBlur}px ${
            getStyles(name).textShadowColor
          }`,
        },
      ]}
    >
      {value ? (
        <center>
          <CodeQrComponent
            qrRef={qrRef}
            size={getStyles(name).width + 100}
            maxWidth={getStyles(name).width + 100}
            value={value}
          />
        </center>
      ) : (
        <center>
          <img
            src={IMG.codeqr2}
            alt="fotoFornatl"
            style={{
              width: `100%`,
              objectFit: 'contain',
            }}
          />
        </center>
      )}
    </Box>
  );
};

export default CodeqrCarnetComponent;
